import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, tone = "text-maroon", light = false, className = "" }) => (
  <Reveal className={`max-w-2xl ${className}`}>
    <p className={`eyebrow ${light ? "text-white/70" : tone}`}>{eyebrow}</p>
    <h2 className={`font-display mt-3 text-3xl leading-tight sm:text-4xl lg:text-[2.75rem] ${light ? "text-white" : "text-ink"}`}>{title}</h2>
    {sub && <p className={`font-en mt-4 text-base md:text-lg ${light ? "text-white/70" : "text-muted2"}`}>{sub}</p>}
  </Reveal>
);
